import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, LockIcon, DownloadIcon } from 'lucide-react';
const KIT_URL = 'https://digital-solvex-ar.myshopify.com/cart/48681186394369:1';
const STORAGE_KEY = 'kit-ml-countdown-end';
const COUNTDOWN_HOURS = 47;
function getEndTime(): number {
  if (typeof window === 'undefined') return Date.now() + COUNTDOWN_HOURS * 3600000;
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored) {
    const end = parseInt(stored, 10);
    if (end > Date.now()) return end;
  }
  const end = Date.now() + COUNTDOWN_HOURS * 3600000;
  localStorage.setItem(STORAGE_KEY, String(end));
  return end;
}
function formatTime(ms: number) {
  if (ms <= 0) return {
    hours: '00',
    minutes: '00',
    seconds: '00'
  };
  const totalSeconds = Math.floor(ms / 1000);
  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
  const minutes = String(Math.floor(totalSeconds % 3600 / 60)).padStart(2, '0');
  const seconds = String(totalSeconds % 60).padStart(2, '0');
  return {
    hours,
    minutes,
    seconds
  };
}
export function FinalCTA() {
  const [remaining, setRemaining] = useState(() => {
    const end = getEndTime();
    return Math.max(0, end - Date.now());
  });
  useEffect(() => {
    const endTime = getEndTime();
    const interval = setInterval(() => {
      const diff = Math.max(0, endTime - Date.now());
      setRemaining(diff);
      if (diff <= 0) clearInterval(interval);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const time = formatTime(remaining);
  return <section className="bg-navy py-16 md:py-24" data-id="element-48">
      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center" data-id="element-49">

        {/* Countdown */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-10" data-id="element-50">
          <p className="text-white/40 text-sm uppercase tracking-wider mb-4" data-id="element-51">
            Esta oferta expira en
          </p>
          <div className="flex items-center justify-center gap-3 md:gap-4" data-id="element-52">
            {[{
            value: time.hours,
            label: 'Horas'
          }, {
            value: time.minutes,
            label: 'Min'
          }, {
            value: time.seconds,
            label: 'Seg'
          }].map((unit, i) => <Fragment key={unit.label} data-id="element-53">
                {i > 0 && <span className="text-gold font-display font-bold text-3xl md:text-4xl -mt-5" data-id="element-54">:</span>}
                <div className="flex flex-col items-center" data-id="element-55">
                  <div className="bg-navy-dark border border-gold/20 rounded-xl w-20 md:w-24 h-20 md:h-24 flex items-center justify-center" data-id="element-56">
                    <span className="font-display font-extrabold text-3xl md:text-4xl gold-shine" data-id="element-57">
                      {unit.value}
                    </span>
                  </div>
                  <span className="text-white/30 text-xs mt-2" data-id="element-58">{unit.label}</span>
                </div>
              </Fragment>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} data-id="element-59">
          <h2 className="font-display font-extrabold text-3xl md:text-4xl lg:text-5xl gold-shine mb-5" data-id="element-60">
            Este precio de lanzamiento no dura para siempre
          </h2>
          <p className="text-white/55 text-lg leading-relaxed mb-8 max-w-xl mx-auto" data-id="element-61">
            Estás a un clic de tener el sistema completo para vender en Mercado
            Libre con ganancia real — todo por $62.900.
          </p>

          <a href={KIT_URL} className="btn-gold inline-block w-full md:w-auto px-12 py-5 rounded-xl font-extrabold text-xl mb-6 no-underline" data-id="element-62">
            SÍ, QUIERO EL KIT COMPLETO AHORA →
          </a>

          <div className="flex items-center justify-center gap-4 md:gap-6 text-white/40 text-sm" data-id="element-63">
            <span className="flex items-center gap-1.5" data-id="element-64">
              <ZapIcon className="w-4 h-4" data-id="element-65" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-66">
              <LockIcon className="w-4 h-4" data-id="element-67" /> Mercado Pago seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-68">
              <DownloadIcon className="w-4 h-4" data-id="element-69" /> Descarga instantánea
            </span>
          </div>
        </motion.div>

      </div>
    </section>;
}